import { Checkbox } from '@xemplo/checkbox';
import { InputFieldSize } from '@xemplo/input-utils';

import { useMultiSelect } from '../../utils/hooks/use-multi-select';

import * as S from './list-select-all.styles';
import { ListSelectAllProps } from './list-select-all.types';

export function ListSelectAll({ className, focusId }: ListSelectAllProps) {
  const { activeDescendantId, isAllSelected, indeterminate, isNoResult, selectAll } =
    useMultiSelect();

  // Don't render the select all when there are no results
  if (isNoResult) return null;

  return (
    <S.SelectAll
      id={focusId}
      role="option"
      className={className}
      tabIndex={activeDescendantId === focusId ? 0 : -1}
      onClick={(e) => {
        // Prevent click event from propagating to checkbox
        // This is necessary to avoid double toggling when clicking the select all checkbox
        e.preventDefault();
        e.stopPropagation();
        selectAll();
      }}
    >
      Select all
      <Checkbox
        value="select-all"
        checked={isAllSelected}
        indeterminate={indeterminate}
        ariaLabel="select all elements in the list"
        size={InputFieldSize.Small}
      />
    </S.SelectAll>
  );
}

export default ListSelectAll;
